/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 17:46:21
 * @LastEditTime: 2021-09-17 16:01:08
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/domain.ts
 */
export enum EnumStatus {
  Connected = 'Connected',
  Verified = 'Verified',
  ActionRequired = 'ActionRequired',
  Pending = 'Pending',
  Invalid = 'Invalid',
  Disconnected = 'Disconnected',
  Deleting = 'Deleting',
  DeleteFailed = 'DeleteFailed',
}

export enum MissingPageRedirectType {
  Page404 = 'Page404',
  MaintenancePage = 'MaintenancePage',
  OtherPage = 'OtherPage',
}
export enum MissingPageType {
  ProductDeleted = 'ProductDeleted',
  PageDeleted = 'PageDeleted',
  PageExpired = 'PageExpired',
  NoAvailableContentVersion = 'NoAvailableContentVersion',
  UrlNotFound = 'UrlNotFound',
}

export enum RequestType {
  All = 'All',
  Domains = 'Domains',
  Redirection = 'Redirection',
}

export enum SSLStatusType {
  Pending = 'Pending',
  Invalid = 'Invalid',
  Verified = 'Verified',
  Expired = 'Expired',
}

export enum DistributionStatus {
  Creating = 'Creating',
  Created = 'Created',
  CreateFail = 'CreateFail',
}

export enum SSLMODE {
  BYO = 'BYO',
  ACME = 'ACME',
}

export enum ACMEStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  VALID = 'VALID',
  INVALID = 'INVALID',
}

export const SSLErrorCodes = [
  701004, 701017, 701022, 701024, 701026, 701025, 208222, 208225,
];

export const DNSErrorCodes = [208223, 208224, 208225];

export const ACMEErrorCodes = ['801001', '801002', '801003'];
